import { SOUNDS_ACTIONS } from 'app/store/actions/media/sounds.actions'
import baseRequestReducer from 'app/store/reducers/base-request.reducer'
import { SoundsInitialState } from 'app/types/sounds-reducer.types'

const initialState: SoundsInitialState = {
  data: {
    items: [],
    groups: [],
  },
  loading: true,
  error: false,
}

const Sounds = baseRequestReducer(initialState, SOUNDS_ACTIONS)

export default Sounds
